export default __webpack_public_path__ + "static/media/xfzyc.ea902672.png";